import React from "react";
import { useNavigate } from "react-router-dom";
import "./ComingSoon.css";

import bonnetImg from "../assets/Bonnet.jpg";
import FadeImg from "./FadeImg";
import { useNavDirection } from "../NavDirectionContext";

// Fiche produit "à venir" : utilisée pour les produits du prochain drop
// (polo, tee) tant que visuels / prix / achat ne sont pas prêts.
export default function ComingSoon({ name = "produit", price = "TBA" }) {
  const navigate = useNavigate();
  const { setDir } = useNavDirection();

  const goBack = () => {
    setDir("down");
    navigate("/shop");
  };

  return (
    <div className="soon">
      <button className="soon__back" onClick={goBack}>
        back
      </button>

      <div className="soon__center">
        <FadeImg
          className="soon__img"
          src={bonnetImg}
          alt={name}
          draggable="false"
        />

        <div className="soon__name">{name}</div>
        <div className="soon__price">{price}</div>
        <div className="soon__tag">coming soon</div>
      </div>
    </div>
  );
}
